import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface ProductCategory {
    product_category_idx: number;
    category_name: string;
}

interface ProductImage {
    file_idx: number;
    file_name: string;
    original_name: string;
}

export interface GetProductResponse {
    product_idx: number;
    product_code_idx: number;
    is_delete: boolean;
    product_code: string;
    product_code_name: string;
    product_name: string;
    product_amount: number;
    product_memo: string;
    product_content: string;
    status: boolean;
    reg_date: string;
    product_category: ProductCategory;
    product_image: ProductImage[];
    notice_image: ProductImage[];
}

export const useGetGoodsInfo = (productId: number): UseQueryResult<GetProductResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetProductResponse, Error>({
        queryKey: ["getGoodsInfo", productId],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_product_info}/${productId}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data;
        },
        enabled: !!productId,
        placeholderData: prevData => {
            if (prevData) {
                return {
                    ...prevData,
                };
            }
            return undefined;
        },
    });
};
